import React from 'react';
import { Outlet, Navigate } from 'react-router-dom';
import Sidebar from './Sidebar';
import Header from './Header';
import AICopilot from './AICopilot';
import './Layout.css';

const Layout = () => {
  const activeStaff = localStorage.getItem('gdt_active_staff');
  const [isSidebarCollapsed, setIsSidebarCollapsed] = React.useState(() => {
    return localStorage.getItem('gdt_sidebar_collapsed') === 'true';
  });

  const toggleSidebar = () => {
    setIsSidebarCollapsed(prev => {
      const next = !prev;
      localStorage.setItem('gdt_sidebar_collapsed', String(next));
      return next;
    });
  };
  
  if (!activeStaff) {
    return <Navigate to="/login/staff" replace />;
  }

  return (
    <div className={`layout ${isSidebarCollapsed ? 'sidebar-collapsed' : ''}`}>
      <Sidebar isCollapsed={isSidebarCollapsed} onToggle={toggleSidebar} />
      <div className="main-container">
        <Header isSidebarCollapsed={isSidebarCollapsed} onToggleSidebar={toggleSidebar} />
        <main className="content">
          <Outlet />
        </main>
      </div>
      <AICopilot />
    </div>
  );
};

export default Layout;
